import { useState, useCallback } from 'react';

export interface ValidationRule {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: RegExp;
  custom?: (value: any, formData?: any) => boolean; 
  message: string;
}

export interface ValidationRules {
  [key: string]: ValidationRule[];
}

export const useFormValidation = <T extends object>(rules: ValidationRules) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isValid, setIsValid] = useState(false);

  const validate = useCallback((data: T): boolean => {
    const newErrors: { [key: string]: string } = {};

    Object.keys(rules).forEach((field) => {
      const value = data[field as keyof T];
      const fieldRules = rules[field];

      for (const rule of fieldRules) {
        if (rule.required && !value) {
          newErrors[field] = rule.message;
          break;
        }
        if (rule.custom && !rule.custom(value, data)) {  // Updated this line to pass data
          newErrors[field] = rule.message;
          break;
        }
      }
    });

    setErrors(newErrors);
    const valid = Object.keys(newErrors).length === 0;
    setIsValid(valid);
    return valid;
  }, [rules]);

  return { errors, validate, isValid };
};